import { Box, Button, Card, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../helpers/Arrays";

const CategoriesTemplate = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            textAlign: "center",
            fontSize: { xs: "40px", sm: "55px" },
            fontWeight: "500",
            color: "primary.darker",
          }}
        >
          Internatioal Robot Challenge 2024
        </Typography>
        <Box
          sx={{
            height: "3px",
            maxWidth: { xs: "100px", md: "350px" },
            width: "100%",
            backgroundColor: "primary.main",
            margin: "10px auto 0 auto",
          }}
        />
        <Typography
          sx={{
            textAlign: "center",
            color: "primary.darker",
            maxWidth: "750px",
            margin: "40px auto 10px auto",
            fontSize: "17px",
          }}
        >
          Each year Internatioal Robot Challenge, one of the world’s largest artificial
          intelligent robotic championships, brings together people from all
          over Egypt who compete with self-made, autonomous robots in various
          competitions.
        </Typography>
      </Box> */}
      <Box
        id={"categories"}
        sx={{
          width: "100%",
          maxWidth: "1500px",
          margin: "auto",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        }}
      >
        <Typography
          variant="h2"
          className="competitions-title"
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "50px" },
            fontWeight: "700",
            color: "primary.darker",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          Our Categories
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "120px", md: "150px" },
            background:
              "linear-gradient(90deg, transparent, #830d0b, transparent)",
            margin: "0 auto 30px auto",
            borderRadius: "2px",
            boxShadow: "0 2px 8px rgba(131, 13, 11, 0.3)",
          }}
        />
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "0px", justifyContent: "center" }}
        >
          {categoriesData?.map((item) => (
            <Grid item xs={12} md={6} xl={6}>
              <Card
                className="category-card"
                sx={{
                  backgroundImage: `linear-gradient(135deg, rgba(131, 13, 11, 0.6) 0%, rgba(0, 0, 0, 0.4) 100%), url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  width: "100%",
                  minHeight: { xs: "300px" },
                  borderRadius: "24px",
                  overflow: "hidden",
                  position: "relative",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 60%)",
                    opacity: 1,
                    transition: "opacity 0.4s ease",
                  },
                  "&:hover": {
                    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.4)",
                    borderColor: "rgba(255, 255, 255, 0.3)",
                    "&::before": {
                      opacity: 0.9,
                    },
                    "& .category-title": {
                      transform: "translateY(-4px)",
                    },
                    "& .category-button": {
                      transform: "translateY(-4px) scale(1.05)",
                    },
                  },
                }}
                onClick={() => navigate(item.link)}
              >
                <Box
                  sx={{
                    position: "relative",
                    zIndex: 1,
                    padding: { xs: "30px 20px", sm: "40px 30px" },
                  }}
                >
                  <Typography
                    className="category-title"
                    variant="h3"
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "28px", sm: "32px", md: "36px" },
                      fontWeight: "700",
                      color: "secondary.main",
                      marginBottom: "12px",
                      textShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                      transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Box
                    sx={{
                      height: "4px",
                      maxWidth: "100px",
                      width: "100%",
                      background:
                        "linear-gradient(90deg, transparent, #fff, transparent)",
                      margin: "0 auto 24px auto",
                      borderRadius: "2px",
                      boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)",
                    }}
                  />
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      className="category-button"
                      variant="contained"
                      color="secondary"
                      sx={{
                        fontSize: { xs: "13px", sm: "15px" },
                        fontWeight: "600",
                        color: "primary.main",
                        padding: { xs: "10px 32px", sm: "12px 40px" },
                        borderRadius: "30px",
                        textTransform: "none",
                        letterSpacing: "0.5px",
                        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.95)",
                          boxShadow: "0 6px 24px rgba(0, 0, 0, 0.4)",
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(item.link);
                      }}
                    >
                      View Details
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
          {/* {categoriesData?.map((item) => (
            <Grid item xs={12} md={6} xl={6}>
              <Box
                sx={{
                  backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  width: "100%",
                  minHeight: { xs: "200px", sm: "300px" },
                  borderRadius: "10px",
                }}
              >
                <Typography
                  variant={"h3"}
                  sx={{
                    textAlign: "center",
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "secondary.main",
                  }}
                >
                  {item.title}
                </Typography>
                <Box
                  sx={{
                    height: "3px",
                    maxWidth: "90px",
                    width: "100%",
                    backgroundColor: "secondary.main",
                    margin: "5px auto 5px auto",
                  }}
                />
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "primary.main",
                      width: "fit-content",
                      margin: { xs: "5px 0 20px 0", sm: "10px 0 40px 0" },
                    }}
                    onClick={() => navigate(item.link)}
                  >
                    view
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))} */}
        </Grid>
      </Box>
    </>
  );
};

export default CategoriesTemplate;
